import { render, staticRenderFns } from "./ResourceLeader.vue?vue&type=template&id=6410eba4&scoped=true"
import script from "./ResourceLeader.vue?vue&type=script&lang=js"
export * from "./ResourceLeader.vue?vue&type=script&lang=js"
import style0 from "./ResourceLeader.vue?vue&type=style&index=0&id=6410eba4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6410eba4",
  null
  
)

export default component.exports